import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ResetPasswordAPI } from "../redux/Auth/actions";
import Modal from "./modal";

const UserId = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Authdata, setAuthdata] = useState({
    email: "",
    name: "",
  });

  const [menu, setMenu] = useState(false);
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [resetData, setResetData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const menuRef = useRef(null);

  const handleMenu = () => {
    setMenu((prev) => !prev);
  };

  const userData = useSelector((state) => state.Auth?.userData?.data);

  const icon = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase();
  };

  useEffect(() => {
    if (userData) {
      setAuthdata({
        email: userData?.email,
        name: userData?.user?.name
          ? userData?.user?.name
          : userData?.store?.name,
      });
    }
  }, [userData]);

  const firstLetter = icon(Authdata?.name);

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const handleResetInputChange = (e) => {
    const { name, value } = e.target;
    setResetData((prev) => ({ ...prev, [name]: value }));
  };

  const handleResetPassword = async () => {
    if (!resetData.oldPassword || !resetData.newPassword || !resetData.confirmPassword) {
      alert("Please fill all fields");
      return;
    }
    if (resetData.newPassword !== resetData.confirmPassword) {
      alert("New password and confirm password do not match");
      return;
    }
    setResetLoading(true);
    await dispatch(ResetPasswordAPI(resetData))
      .then((res) => {
        setResetLoading(false);
        if (res?.status === 200) {
          setIsResetModalOpen(false);
          setResetData({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        }
      })
      .catch((err) => {
        setResetLoading(false);
        console.log("Reset password error", err);
      });
  };

  return (
    <div
      ref={menuRef}
      className="text-xl flex items-center gap-2.5 cursor-pointer"
    >
      <p className="max-md:hidden" onClick={() => handleMenu()}>{Authdata?.name}</p>
      <div className="relative w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center">
        <p className="font-medium" onClick={() => handleMenu()}>{firstLetter}</p>
        <div
          className={`${
            menu ? "visible" : "invisible"
          } absolute top-14 rounded-md overflow-hidden border right-1 bg-white text-black z-50 shadow-md`}
        >
          <div className="border-b px-4 py-2 bg-bodyBg">
            <p className="text-base font-medium">Profile</p>
          </div>
          <div className="px-4 py-3 border-b flex items-center gap-2">
            <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center">
              <p className="font-medium">{firstLetter}</p>
            </div>
            <div>
              <p className="text-base text-nowrap">{Authdata?.name}</p>
              <p className="text-base text-nowrap">{Authdata?.email}</p>
            </div>
          </div>
          <div
            onClick={() => {
              setIsResetModalOpen(true);
              setMenu(false);
            }}
            className="flex items-center justify-center px-4 py-2 text-base border-b hover:bg-gray-100"
          >
            Reset Password
          </div>
          <div
            onClick={() => handleLogout()}
            className="flex items-center justify-center px-4 py-2 text-base bg-bodyBg hover:text-red-600"
          >
            Logout
          </div>
        </div>
      </div>

      <Modal
        isOpen={isResetModalOpen}
        closeModal={() => setIsResetModalOpen(false)}
        title="Reset Password"
        modalWidth="max-w-[450px]"
        loading={resetLoading}
        btn2="Update Password"
        btnClass="justify-center"
        handleBtn2={handleResetPassword}
        modalContent={
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium" htmlFor="oldPassword">Old Password</label>
              <input
                className="h-12 w-full pl-4 rounded-xl border focus:outline-none text-base"
                type="password"
                name="oldPassword"
                placeholder="Enter Old Password"
                value={resetData.oldPassword}
                onChange={handleResetInputChange}
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium" htmlFor="newPassword">New Password</label>
              <input
                className="h-12 w-full pl-4 rounded-xl border focus:outline-none text-base"
                type="password"
                name="newPassword"
                placeholder="Enter New Password"
                value={resetData.newPassword}
                onChange={handleResetInputChange}
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium" htmlFor="confirmPassword">Confirm Password</label>
              <input
                className="h-12 w-full pl-4 rounded-xl border focus:outline-none text-base"
                type="password"
                name="confirmPassword"
                placeholder="Confirm New Password"
                value={resetData.confirmPassword}
                onChange={handleResetInputChange}
              />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default UserId;
